module.exports = __webpack_public_path__ + "static/media/vesi.14b09d58.png";